import { Collection } from 'modules/core/lib/mobx-rest'

import Observation from 'modules/payroll_bundle/store/models/Observation'

class Observations extends Collection<Observation> {
  get cacheKey(): string {
    return 'observations'
  }

  model() {
    return Observation
  }
}

const singleton: Observations = new Observations([])

export default singleton
